module.exports = __webpack_public_path__ + "static/media/image-card-5.8c4d67f2.png";